export const resizeImage = (file: File): Promise<Blob> => {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = (event: ProgressEvent<FileReader>) => {
      const img = new Image();
      img.crossOrigin = 'anonymous';  // Add CORS support
      
      if (event.target?.result) {
        img.src = event.target.result.toString();
      } else {
        reject(new Error('Failed to load image'));
        return;
      }
      
      img.onload = () => {
        const MAX_SIZE = 1000;
        let width = img.width;
        let height = img.height;

        // Calculate new dimensions
        if (width > height && width > MAX_SIZE) {
          height *= MAX_SIZE / width;
          width = MAX_SIZE;
        } else if (height > MAX_SIZE) {
          width *= MAX_SIZE / height;
          height = MAX_SIZE;
        }

        // Create canvas and resize
        const canvas = document.createElement('canvas');
        canvas.width = width;
        canvas.height = height;
        const ctx = canvas.getContext('2d');
        
        if (!ctx) {
          reject(new Error('Failed to get canvas context'));
          return;
        }
        
        ctx.drawImage(img, 0, 0, width, height);

        // Convert to Blob
        canvas.toBlob(
          (blob) => {
            if (blob) {
              resolve(blob);
            } else {
              reject(new Error('Failed to create blob'));
            }
          },
          file.type,
          0.9
        ); // 0.9 quality for JPEG
      };
      img.onerror = () => reject(new Error('Failed to load image'));
    };
    reader.onerror = () => reject(new Error('Failed to read file'));
  });
};

export const validateImageFile = (file: File): boolean => {
  const validTypes = ['image/jpeg', 'image/png', 'image/heic'];
  if (!validTypes.includes(file.type.toLowerCase())) {
    throw new Error('Please upload a JPG, PNG, or HEIC image');
  }
  if (file.size > 10 * 1024 * 1024) { // 10MB limit
    throw new Error('Image must be smaller than 10MB');
  }
  return true;
}; 